export const AUTH_MODAL_POSSIBILITIES = [
  "LOGIN",
  "SIGNUP",
  "RESETPASSWORD",
  "RESETPASSWORDCONFIRMATION",
] as const;

export type AuthModalPossibilities = (typeof AUTH_MODAL_POSSIBILITIES)[number];
